
<template>
    <clockForm :id="id" :isLook="isLook"></clockForm>
</template>

<script>
import clockForm from './form'
export default {
    components: {
        clockForm
    },
    data() {
        return {
            id: null,
            isLook: true,
        }
    },
    mounted() {
        const { id } = this.$route.params
        this.id = id
    },
    methods: {
        
    }
}
</script>